import React, { FC } from "react";

import {
    CardActivities,
    CardAll,
    CardFamily,
    CardHouse,
    CardLegalProtections,
    CardLeisure,
    CardManager,
    CardOther,
    CardPack,
    CardSavings,
    CardVehicle,
    CardWorld,
} from "@/assets/images/categories/card";

export const ContractCategoryIcon: FC<{ categoryId: string }> = ({ categoryId }) => {
    switch (categoryId) {
        case "0":
            return <CardAll />;
        case "1":
            return <CardVehicle />;
        case "2":
            return <CardHouse />;
        case "3":
            return <CardFamily />;
        case "4":
            return <CardLeisure />;
        case "5":
            return <CardSavings />;
        case "6":
            return <CardPack />;
        case "7":
            return <CardLegalProtections />;
        case "8":
            return <CardActivities />;
        case "9":
            return <CardWorld />;
        case "10":
            return <CardManager />;
        default:
            return <CardOther />;
    }
};
